import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ContentCategory, Content, ContentSearch } from 'src/app/models/content';
import { User } from 'src/app/models/user';
import { AuthService } from 'src/app/services/auth.service';
import { CommonService } from 'src/app/services/common.service';
import { ContentService } from 'src/app/services/content.service';
import { MypageCommonDialogComponent } from '../../mypage/mypage-common-dialog/mypage-common-dialog.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-mobile-guide',
  templateUrl: './mobile-guide.component.html',
  styleUrls: ['./mobile-guide.component.css']
})
export class MobileGuideComponent implements OnInit {

  constructor(
    private commonService: CommonService,
    private authService: AuthService,
    private contentService: ContentService,
    private spinner: NgxSpinnerService,
    private matDialog: MatDialog,
    private router: Router
  ) { 
    if(!this.commonService.getIsMobile()) {
      this.router.navigate(['/guide'])
    }
  }

  user: User
  contentCategoryList: ContentCategory[] = new Array()
  ngOnInit(): void {
    let allCateogry = new ContentCategory()
    allCateogry.contentCategoryName = '전체보기'
    allCateogry.contentCategoryNo = 0
    this.user = this.commonService.getUserInfo()
    this.contentService.getCategoryList('GUIDE').subscribe(res => {
      this.contentCategoryList = (res.data.contentCategoryList)
      this.contentCategoryList.unshift(allCateogry)
    })
    this.getGuideList()
  }
  contentCategoryNo: number = 0
  guideList: Content[]
  selectCategory(categoryNo: number) {
    this.contentCategoryNo = categoryNo
    this.getGuideList()
  }
  selectContent(item: Content) {
    this.guideList.forEach(c => c.selected = false)
    item.selected = true
  }
  getGuideList() {
    let search = new ContentSearch()
    search.fromDate = null
    search.toDate = null
    search.contentCategoryNo = this.contentCategoryNo
    search.contentMasterId = 'GUIDE'
    search.statusList = ['ON']
    search.rows = 100
    search.sort = 'seq'
    search.direction = 'asc'
    this.spinner.show();
    this.contentService.getContentList(search).subscribe(res => {
      this.spinner.hide()
      this.guideList = res.data.content
      if(this.guideList && this.guideList.length > 0) {
        this.guideList[0].selected = true
      }
    })
  }
  openMypageCommonPopup(type: string) {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.disableClose = false
    dialogConfig.id = "mypageCommonWindow"
    //dialogConfig.width = "640px"
    //dialogConfig.height = "600px"
    dialogConfig.data = { 
        userNo: this.user.userNo
      , type: type
      , user: this.user
    }
    const matDialog = this.matDialog.open(MypageCommonDialogComponent, dialogConfig);
    matDialog.afterClosed().subscribe(res => {
      //none
    })
  }
  logout(){
    this.authService.logout()
  }

}
